// Mêmes valeurs que les barres de défilement globales d'index.css
const SCROLLBAR_COLORS = {
  light: { track: '#e8eaed', thumb: '#c1c4c8', thumbHover: '#a8abb0' },
  dark: { track: '#1a252f', thumb: '#2d3f4c', thumbHover: '#384550' },
};

// Les iframes TinyMCE n'héritent pas des styles d'index.css
export const getScrollbarCss = (isDark) => {
  const { track, thumb, thumbHover } = SCROLLBAR_COLORS[isDark ? 'dark' : 'light'];
  return `
      html { scrollbar-width: thin; scrollbar-color: ${thumb} ${track}; }
      ::-webkit-scrollbar { width: 8px; height: 8px; }
      ::-webkit-scrollbar-track { background-color: ${track}; }
      ::-webkit-scrollbar-thumb { background-color: ${thumb}; border-radius: 4px; }
      ::-webkit-scrollbar-thumb:hover { background-color: ${thumbHover}; }
  `;
};
